document.addEventListener("DOMContentLoaded", function () {
  const printButton = document.querySelector(".print-button");

  if (printButton) {
    printButton.addEventListener("click", function () {
      window.print();
    });
  }
});
